import styled from "styled-components";
import { CreateExperienceCard } from "./CreateExperienceCard";
import { AnalyticsCards } from "./AnalyticsCards";
import { ChromeExtensionCard } from "./ChromeExtensionCard";

export type ActionCardsProps = {
  isProjectQuotaReached: boolean;
  isNearQuota?: boolean;
};

export const ActionCards = ({
  isProjectQuotaReached,
  isNearQuota,
}: ActionCardsProps) => {
  return (
    <ActionCardsRow>
      <ActionCardsScrollArea>
        <CreateExperienceCard
          isProjectQuotaReached={isProjectQuotaReached}
          isNearQuota={isNearQuota}
        />

        <AnalyticsCards />
      </ActionCardsScrollArea>

      <ActionCardsSeparator />

      <ChromeExtensionCard />
    </ActionCardsRow>
  );
};

const ActionCardsRow = styled.div`
  display: flex;
  gap: 16px;
  align-items: stretch;
  min-width: 0;

  @media (width <= 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const ActionCardsScrollArea = styled.div`
  display: flex;
  gap: 16px;
  align-items: stretch;
  flex: 1;
  min-width: 0;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 8px;

  @media (width <= 768px) {
    flex: 0 0 auto;
    width: 100%;
  }

  /* Hide scrollbar but keep functionality */
  scrollbar-width: thin;
  scrollbar-color: rgba(111, 116, 127, 0.3) transparent;

  &::-webkit-scrollbar {
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(111, 116, 127, 0.3);
    border-radius: 3px;
  }

  > * {
    scroll-snap-align: start;
  }
`;

const ActionCardsSeparator = styled.div`
  width: 1px;
  align-self: stretch;
  background-color: rgba(111, 116, 127, 0.15);
  flex-shrink: 0;
  margin: 8px 0;
  margin-left: auto;

  @media (width <= 768px) {
    width: auto;
    height: 1px;
    align-self: auto;
    margin: 0;
  }
`;
